import { render } from "./CostTypeList.vue?vue&type=template&id=4c956078&scoped=true"
import script from "./CostTypeList.vue?vue&type=script&lang=js"
export * from "./CostTypeList.vue?vue&type=script&lang=js"

import "./CostTypeList.vue?vue&type=style&index=0&id=4c956078&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c956078"]])

export default __exports__